import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterContacts',
})
export class FilterContactsPipe implements PipeTransform {
  transform(
    allContacts: any[],
    deskId: string,
    allSelectedContacts: any[],
    currentRowIndex: number
  ): any[] {
    if (!deskId) {
      return [];
    }

    return allContacts.filter((contact) => {
      return (
        contact.deskId === deskId &&
        !allSelectedContacts
          .filter((_, i) => i !== currentRowIndex)
          .some((c) => c.contactId === contact.id)
      );
    });
  }
}
